/**
 * The reset flow's one refusal alert — a translated sentence chosen by `classifyResetError` (or a
 * client check), never the server's English. A password-policy refusal carries its own translated
 * sentence (`text`, from `usePasswordRefusalText`: it names each failed requirement), which wins over
 * the class key. Module-private to the reset flow.
 *
 * @module @puffin-core/login-shell/components/passwordReset/ResetErrorAlert
 */

import PropTypes from 'prop-types';
// The NARROW subpath, never the barrel: login-shell is router-free (see ContactManagerModal).
import { InlineFeedback } from '@puffin-core/page-shell/inline-feedback';

/**
 * @param {Object} props
 * @param {{key: string, params?: Object, text?: string}|null} props.error
 * @param {Function} props.translate - the login-corpus translator
 * @returns {React.JSX.Element|null}
 */
export function ResetErrorAlert({ error, translate }) {
  if (!error) return null;
  // SAVE-FEEDBACK-001 (SAVE-FEEDBACK-CANON-001 P3): the refusal is the ONE feedback component —
  // `role="alert"` is its, never hand-written `.alert` markup. The step's form spaces nothing itself,
  // so the margin that kept the alert off the field below stays, on a wrapper.
  return (
    <div className="mb-md">
      <InlineFeedback
        tone="error"
        message={error.text || translate(error.key, error.params)}
        testId="reset-error"
      />
    </div>
  );
}

ResetErrorAlert.propTypes = {
  error: PropTypes.shape({
    key: PropTypes.string.isRequired,
    params: PropTypes.object,
    text: PropTypes.string,
  }),
  translate: PropTypes.func.isRequired,
};

export default ResetErrorAlert;
